import { createFileRoute, redirect } from "@tanstack/react-router";

// Link curto para falar nos vídeos: nutriclaracamille.com.au/quiz (mantém as UTMs).
export const Route = createFileRoute("/quiz")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: `/diagnostico${location.searchStr ?? ""}`, statusCode: 302 });
  },
});
